import { Component, OnInit, AfterViewInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GeneralService } from '../../../services/general.service';
import { GLOBAL } from '../../../services/global';

declare const $: any;

@Component({
  selector: 'app-header-promotion',
  templateUrl: './header-promotion.component.html',
  styleUrls: ['./header-promotion.component.css'],
})
export class HeaderPromotionComponent implements OnInit, AfterViewInit, OnDestroy {
  public identity;
  public url: string;
  public topbanners: any[] = [];
  public token;
  public preload: boolean = true;
  private resizeTimer: any;
  private carouselInitialized: boolean = false;
  private initAttempts: number = 0;
  private maxAttempts: number = 5;
  
  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _generalService: GeneralService,
    private cdr: ChangeDetectorRef
  ) {
    this.url = GLOBAL.url;
    this.token = this._generalService.getToken();
  }

  ngOnInit() {
    this.identity = this._generalService.getIdentity();
    this.getTopBanner();
  }
  
  ngAfterViewInit() {
    window.addEventListener('resize', this.handleResize.bind(this));
  }
  
  ngOnDestroy() {
    window.removeEventListener('resize', this.handleResize.bind(this));
    
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
    
    this.destroyCarousel();
  }
  
  handleResize() {
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
    
    this.resizeTimer = setTimeout(() => {
      if (this.carouselInitialized) {
        try {
          const carousel = $('#banner-carousel');
          if (carousel && carousel.data('owl.carousel')) {
            carousel.trigger('refresh.owl.carousel');
          }
        } catch (e) {
          console.error('Error refreshing carousel:', e);
        }
      }
    }, 250);
  }
  
  // Método seguro para inicializar el carrusel
  initCarousel() {
    // Incrementar contador de intentos
    this.initAttempts++;
    
    // Si ya lo intentamos demasiadas veces, detener
    if (this.initAttempts > this.maxAttempts) {
      console.warn('Max carousel initialization attempts reached');
      return;
    }
    
    // Comprobar si hay datos y elementos DOM
    if (!this.topbanners || this.topbanners.length === 0) {
      console.log('No banner data available, delaying initialization');
      setTimeout(() => this.initCarousel(), 500);
      return;
    }
    
    const carouselElement = $('#banner-carousel');
    if (!carouselElement || carouselElement.length === 0) {
      console.log('Carousel element not found in DOM, delaying initialization');
      setTimeout(() => this.initCarousel(), 500);
      return;
    }
    
    // Comprobar si los elementos hijos están listos
    if (carouselElement.children().length === 0) {
      console.log('Carousel has no child elements, delaying initialization');
      setTimeout(() => this.initCarousel(), 500);
      return;
    }
    
    // Destruir instancia previa si existe
    this.destroyCarousel();
    
    try {
      console.log('Initializing carousel with', this.topbanners.length, 'items');
      
      // Forzar actualización del DOM antes de inicializar
      this.cdr.detectChanges();
      
      // Usar setTimeout para asegurar que el DOM está listo
      setTimeout(() => {
        try {
          // Inicializar con opciones básicas primero
          carouselElement.owlCarousel({
            items: 1,
            loop: this.topbanners.length > 1,  // Solo activar loop si hay múltiples items
            margin: 0,
            nav: false,
            dots: true
          });
          
          // Si se inicializa correctamente, configurar opciones completas
          if (carouselElement.data('owl.carousel')) {
            carouselElement.trigger('destroy.owl.carousel');
            
            carouselElement.owlCarousel({
              items: 1,
              loop: true,
              autoplay: true,
              autoplayTimeout: 5000,
              autoplaySpeed: 1000,
              autoplayHoverPause: true,
              nav: false,
              navText: false,
              dots: true,
              smartSpeed: 500,
              mouseDrag: true,
              touchDrag: true,
              pullDrag: true,
              freeDrag: false,
              margin: 0,
              stagePadding: 0,
              merge: false,
              mergeFit: true,
              autoWidth: false,
              startPosition: 0,
              rtl: false,
              center: false,
              lazyLoad: false, // Desactivado para evitar problemas
              responsive: {
                0: { items: 1 },
                576: { items: 1 },
                768: { items: 1 },
                992: { items: 1 }
              },
              responsiveRefreshRate: 200,
              video: false,
              animateOut: false,
              animateIn: false,
              autoHeight: false,
              URLhashListener: false
            });
            
            this.carouselInitialized = true;
            console.log('Carousel successfully initialized');

            this.removeNavigationButtons();

          }
        } catch (error) {
          console.error('Error during carousel initialization:', error);
          
          // Intentar con enfoque alternativo (vanilla JS)
          if (!this.carouselInitialized && this.initAttempts <= this.maxAttempts) {
            console.log('Trying alternative initialization approach');
            setTimeout(() => this.fallbackInitCarousel(), 500);
          }
        }
      }, 100);
    } catch (error) {
      console.error('Error setting up carousel:', error);
    }
  }
  
  // Enfoque alternativo de inicialización
  fallbackInitCarousel() {
    try {
      // Crear estructura mínima para el carrusel
      const container = document.getElementById('banner-carousel');
      if (!container) return;
      
      // Limpiar contenedor
      container.innerHTML = '';
      
      // Recrear elementos manualmente
      this.topbanners.forEach((banner, index) => {
        const slide = document.createElement('div');
        slide.className = 'custom-banner-slide';
        
        const imageContainer = document.createElement('div');
        imageContainer.className = 'custom-banner-image';
        
        const img = document.createElement('img');
        img.src = this.validateImageUrl(banner.tagImg);
        img.alt = 'Banner promocional';
        
        imageContainer.appendChild(img);
        slide.appendChild(imageContainer);
        
        // Agregar contenido de texto también
        const contentContainer = document.createElement('div');
        contentContainer.className = 'custom-banner-content';
        
        const textContainer = document.createElement('div');
        textContainer.className = 'banner-text-container';
        textContainer.innerHTML = `
          <h2 class="banner-title">${banner.tagH3 || ''}</h2>
          <p class="banner-description">${banner.tagP1 || ''}</p>
          <h4 class="banner-subtitle">${banner.tagH4 || ''}</h4>
          <div class="banner-highlight">
            <p>${banner.tagP2 || ''} <span>${banner.tagSpan || ''}</span></p>
          </div>
        `;
        
        contentContainer.appendChild(textContainer);
        slide.appendChild(contentContainer);
        
        container.appendChild(slide);
      });
      
      // Usar jQuery para inicializar con opciones mínimas
      $(container).owlCarousel({
        items: 1,
        loop: this.topbanners.length > 1,
        nav: false,
        navText: false,
        dots: true
      });
      
      this.carouselInitialized = true;
      console.log('Fallback carousel initialized');

      this.removeNavigationButtons();

    } catch (error) {
      console.error('Error in fallback initialization:', error);
    }
  }
  
  // Destruir instancia del carrusel
  destroyCarousel() {
    try {
      const carousel = $('#banner-carousel');
      if (carousel && carousel.data('owl.carousel')) {
        carousel.trigger('destroy.owl.carousel');
        this.carouselInitialized = false;
      }
    } catch (e) {
      console.error('Error destroying carousel:', e);
    }
  }
  
  // Validar URL de imagen
  validateImageUrl(url: string): string {
    if (!url || url === '') {
      return 'assets/img/default-banner.jpg';
    }
    
    if (!url.startsWith('http') && !url.startsWith('/')) {
      return this.url + url;
    }
    
    return url;
  }
  
  // Obtener datos del banner
  getTopBanner() {
    this.preload = true;
    
    const object = {
      url: 'TopBanner/GetTopBanner',
      token: this.token,
    };
    
    this._generalService.getObject(object).subscribe(
      (response) => {
        if (response && Array.isArray(response) && response.length > 0) {
          console.log('Banner data received:', response);
          this.topbanners = response;
          this.preload = false;
          
          // Dejar que el DOM se actualice y luego inicializar
          setTimeout(() => {
            this.initCarousel();
          }, 300);
        } else {
          console.warn('No banner data received or empty array');
          this.topbanners = [];
          this.preload = false;
        }
      },
      (error) => {
        console.error('Error loading banners:', error);
        this.topbanners = [];
        this.preload = false;
      }
    );
  }

  ngDoCheck() {
    this.identity = this._generalService.getIdentity();
  }

  // Añade esta función después de destroyCarousel()
removeNavigationButtons() {
  try {
    // Usar setTimeout para asegurar que el DOM está actualizado
    setTimeout(() => {
      // Eliminar completamente el contenedor .owl-nav
      $('.owl-nav').remove();
      
      // También eliminar las flechas de navegación si existen
      $('.owl-prev, .owl-next').remove();
      
      console.log('Navigation elements completely removed from DOM');
    }, 100);
  } catch (e) {
    console.error('Error removing navigation:', e);
  }
}
}